import { useEffect, useRef, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { useAppContext } from '../../../appProvider/contextProvider';
import IconCropper from '../../../components/IconCropper/iconCropper';
import NotificationPreview from '../../../components/NotificationPreview/NotificationPreview';
import { ERRORS, URL_VALIDATOR } from '../../../constants/AppConstants';
import { updateWelcomeNotifications } from '../../../services/automationService';
import { getOverAllStats } from '../../../services/overAllStats';
import getCroppedImage from '../../../Util/getCroppedImage';
import roundOff from '../../../Util/roundOff';




const WelcomeNotification = () => {

    const history = useHistory();

    const bannerRef = useRef(null);
    const iconRef = useRef(null);

    const { selectedWebsite, 
        setSelectedWebsite,
        setPathToNavigate,
        setDiscardPromptOpen,
        isDirty, 
        setIsDirty 
    } = useAppContext();


    const [welcomeNotification, setWelcomeNotification] = useState(null);

    const [is_cta_enabled, setCTAEnabled] = useState(false);
    const [isCTA2Enabled, setCTA2Enabled] = useState(false);

    const [title, setTitle] = useState('');
    const [titleError, setTitleError] = useState(null);

    const [message, setMessage] = useState('');
    const [messageError, setMessageError] = useState(null);
    const [messageLengthError, setMessageLengthError] = useState(null);

    const [landing_url, setWelcomeLink] = useState('');
    const [welcomeLinkError, setWelcomeLinkError] = useState(null);
    const [is_enabled, setIsEnabled] = useState(true);

    const [iconPath, setIconPath] = useState('');
    const [iconName, setIconName]= useState('');
    const [openCropper, setOpenCropper] = useState(false);
    const [icon, setIcon] = useState(null);
    const [iconDisplayPath, setIconDisplayPath] = useState('');

    const [bannerPath, setBannerPath] = useState('');
    const [bannerName, setBannerName]= useState('');
    const [openBannerCropper, setOpenBannerCropper] = useState(false);
    const [banner, setBanner] = useState(null);
    const [bannerDisplayPath, setBannerDisplayPath] = useState('');

    const [cta1Title, setCta1Title] = useState('');
    const [cta1TitleError, setCTA1TitleError] = useState(null);
    const [cta1URL, setCta1URL] = useState('');
    const [cta1URLError, setCTA1URLError] = useState(null);


    const [cta2Title, setCta2Title] = useState('');
    const [cta2TitleError, setCTA2TitleError] = useState(null);
    const [cta2URL, setCta2URL] = useState('');
    const [cta2URLError, setCTA2URLError] = useState(null);

    const [ welcomeStats, setWelcomeStats ] = useState({});

    useEffect(() => {
        const discard =  () => {
            reset();
        }
        document.addEventListener('discardEvent', discard);

        return () => {
            document.removeEventListener('discardEvent', discard);
        }
    }, [])
    
    useEffect(() => {
       reset();
    }, [selectedWebsite?.welcome_notification]);
    
 
    useQuery(
        ['fetchWelcomeNotificationStats', selectedWebsite?.id], 
        () => getOverAllStats(selectedWebsite?.id),
        {
            enabled: !!selectedWebsite,
            onSuccess: (stats) => {
                setWelcomeStats(stats.welcome);
            }
        }
    )

    const handelTitleChange = (value) => {
        
        if(value.trim().length <=0 ) {
            setTitleError(ERRORS.TITLE_REQUIRED);
        }
        else {
            setTitleError(null);
        }
        setIsDirty(true);
        if(value.trim().length <= 100 ) {
            setTitle(value);
        }
    }

    const handelMessageChange = (value) => {
        
        if(value.trim().length > 120 ) {
            setMessageLengthError(ERRORS.WEBSITE_MESSAGE_MAX_LENGTH);
        }
        else {
            setMessageLengthError(null)
            setMessageError(null);
        }
        setIsDirty(true);
        if(value.trim().length <= 300 ) {
            setMessage(value);
        }
    }

    const handelWelcomeLinkChange = (value) => {
        
        if(value.trim().length <=0 ) {
            setWelcomeLinkError(ERRORS.WELCOME_LINK_REQUIRED);
        } else if(!value.match(URL_VALIDATOR)) {
            setWelcomeLinkError(ERRORS.WEBSITE_URL_VALID);
        }
        else {
            setWelcomeLinkError(null);
        }
        setIsDirty(true);
        if(value.trim().length <= 150 ) {
            setWelcomeLink(value);
        }
    }

    const handelIconUpload = (({target}) => {
        if(target.files && target.files[0]) {
            const url = URL.createObjectURL(target.files[0]);
            setIconName(target.files[0].name);
            setIconPath(url);
            setOpenCropper(true);
            iconRef.current.value = '';
            setIsDirty(true);
        }
    });

    const onCancelIconCrop = () => {
        if(welcomeNotification && welcomeNotification?.icon) {
            setIconPath(welcomeNotification?.icon);
        } else {
            setIconPath('');
        }
        setIconDisplayPath('');
        setOpenCropper(false);
        setIconName('');
    }
    
    const getCroppedIcon = async (croppedAreaPixel) => {
        const {url, file} = await getCroppedImage(
            iconPath,
            croppedAreaPixel,
            0,
            iconName,
        );
        setIconDisplayPath(url);
        setIconPath(url);
        setIcon(file);
        setOpenCropper(false);
    }

    const handelBannerUpload = (({target}) => {
        if(target.files && target.files[0]) {
            const url = URL.createObjectURL(target.files[0]);
            setBannerPath(url);
            setBannerName(target.files[0].name);
            setOpenBannerCropper(true);
            bannerRef.current.value = '';
            setIsDirty(true);
        }
    });

    const onCancelBannerCrop = () => {
        if(welcomeNotification && welcomeNotification?.banner_image) {
            setBannerPath(welcomeNotification?.banner_image);
        } else {
            setBannerPath('');
        }
        setBannerDisplayPath('');
        setOpenBannerCropper(false);
        setBannerName('');
    }
    
    const getCroppedBanner = async (croppedAreaPixel) => {
        const {url, file} = await getCroppedImage(
            bannerPath,
            croppedAreaPixel,
            0,
            bannerName,
        );
        setBannerDisplayPath(url);
        setBannerPath(url);
        setBanner(file);
        setOpenBannerCropper(false);
    }

    const handelCTA1TitleChange = (value) => {
        if(value.trim().length <=0 ) {
            setCTA1TitleError(ERRORS.TITLE_REQUIRED);
        } 
        else {
            setCTA1TitleError(null);
        }
        if(value.trim().length <= 20 ) {
            setCta1Title(value);
        }
        
        setIsDirty(true);
    }

    const handelCTA1URLChange = (value) => {
        
        if(value.trim().length <=0 ) {
            setCTA1URLError(ERRORS.WEBSITE_URL_REQUIRED);
        } else if(!value.match(URL_VALIDATOR)) {
            setCTA1URLError(ERRORS.WEBSITE_URL_VALID);
        }
        else {
            setCTA1URLError(null);
        }
        if(value.trim().length <= 150 ) {
            setCta1URL(value);
        }
        setIsDirty(true);
        
    }

    const handelCTA2TitleChange = (value) => {
        
        if(value.trim().length <=0 ) {
            setCTA2TitleError(ERRORS.TITLE_REQUIRED);
        }
        else {
            setCTA2TitleError(null);
        }
        if(value.trim().length <= 20 ) {
            setCta2Title(value);
        }
        setIsDirty(true);
    }

    const handelCTA2URLChange = (value) => {
        
        if(value.trim().length <=0 ) {
            setCTA2URLError(ERRORS.WEBSITE_URL_REQUIRED);
        } else if(!value.match(URL_VALIDATOR)) {
            setCTA2URLError(ERRORS.WEBSITE_URL_VALID);
        }
        else {
            setCTA2URLError(null);
        }
        if(value.trim().length <= 150 ) {
            setCta2URL(value);
        }
        setIsDirty(true);
    }

    const isSaveDisabled = () => {
        return title.length <= 0  || titleError || messageError || landing_url.length <= 0 || welcomeLinkError ||
            (is_cta_enabled && ( cta1Title.length <= 0 || cta1URL.length <= 0 || cta1TitleError || cta1URLError)) ||
            (isCTA2Enabled && ( cta2Title.length <= 0 || cta2URL.length <= 0 || cta1TitleError || cta1URLError ));
    }

    const reset = () => {

        setTitleError(null);
        setMessageError(null);
        setMessageLengthError(null)
        setWelcomeLinkError(null);
        setCTA1TitleError(null);
        setCTA1URLError(null);
        setCTA2TitleError(null);
        setCTA2URLError(null);

        setIcon(null);
        setBanner(null);

        setWelcomeNotification(selectedWebsite?.welcome_notification);
        setTitle(selectedWebsite?.welcome_notification?.title || '');
        setMessage(selectedWebsite?.welcome_notification?.message || '');
        setWelcomeLink(selectedWebsite?.welcome_notification?.landing_url || '');
        setIsEnabled(selectedWebsite?.welcome_notification?.is_enabled || '');
        if(selectedWebsite?.welcome_notification.icon) {
            setIconPath(selectedWebsite?.welcome_notification.icon);
            setIconName('icon.jpg');
            setIconDisplayPath(selectedWebsite?.welcome_notification.icon);
        } else {
            setIconPath('');
            setIconName('');
            setIconDisplayPath('');
        }
        if(selectedWebsite?.welcome_notification.banner_image) {
            setBannerDisplayPath(selectedWebsite?.welcome_notification.banner_image)
            setBannerPath(selectedWebsite?.welcome_notification.banner_image);
            setBannerName('banner.jpg');
        } else {
            setBannerPath('');
            setBannerName('');
        }
        if(selectedWebsite?.welcome_notification?.is_cta_enabled) {
            setCTAEnabled(selectedWebsite?.welcome_notification?.is_cta_enabled);
            setCta1Title(selectedWebsite?.welcome_notification?.button);
            setCta1URL(selectedWebsite?.welcome_notification?.url || '');
            if(selectedWebsite?.welcome_notification?.addl_button) {
                setCTA2Enabled(true);
                setCta2Title(selectedWebsite?.welcome_notification?.addl_button || '');
                setCta2URL(selectedWebsite?.welcome_notification?.addl_url || '');
            }
        }
        setIsEnabled(selectedWebsite?.welcome_notification?.is_enabled);

    }

    const save = (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append('title', title);
        formData.append('message', message);
        formData.append('is_cta_enabled', is_cta_enabled);
        formData.append('is_enabled', is_enabled);
        formData.append('landing_url', landing_url);
        if(is_cta_enabled) {
            formData.append('button', cta1Title);
            formData.append('url', cta1URL);
            if(isCTA2Enabled) {
                formData.append('addl_button', cta2Title);
                formData.append('addl_url', cta2URL);
            } else {
                formData.append('addl_button', '');
                formData.append('addl_url', '');
            }
        } else {
            formData.append('button', '');
            formData.append('url', '');
            formData.append('addl_button', '');
            formData.append('addl_url', '');
        }
        if(banner) {
            formData.append('banner_image', banner);
        } else if(!banner && !bannerPath) {
            formData.append('banner_image', '');
        }
        if(icon) {
            formData.append('icon', icon);
        }else if(!icon && !iconPath) {
            formData.append('icon', '');
        }
        saveWelcomeNotification.mutate(formData);
    }

    const saveWelcomeNotification = useMutation((formData) => {
        return updateWelcomeNotifications(selectedWebsite?.id, formData)}, {
            onSuccess: ((welcomeNotification) => {
                if(welcomeNotification.errors) {

                } else {
                    const tempSelectedWebsite = {...selectedWebsite};
                    tempSelectedWebsite.welcome_notification = welcomeNotification;
                    setSelectedWebsite(tempSelectedWebsite);
                    toast.success('Welcome Notification saved successfully');
                    setIsDirty(false);
                }
            }),
            onError: ((error) => {
                console.log(error);
                // toast.error(error.message);
            })
    });

    const discard = () => {
        setDiscardPromptOpen(true);
    }



    const onClearBanner = () => {
        setIsDirty(true);
        setBanner(null);
        setBannerPath('');
        setBannerDisplayPath('');
        setBannerName('');
    }
  
    const onClearIcon = () => {
        setIsDirty(true);
        setIcon(null);
        setIconPath('');
        setIconName('');
        setIconDisplayPath('');
    }

    const deleteCta1 = () => {
        setIsDirty(true);
        setCTAEnabled(!is_cta_enabled);
        setCta1Title('');
        setCta1URL('');
        setCTA1TitleError(null);
        setCTA1URLError(null);
        deleteCta2();
        setIsDirty(true);
    }

    const deleteCta2 = () => {
        setIsDirty(true);
        setCTA2Enabled(false);
        setCta2Title('');
        setCta2URL('');
        setCTA2TitleError(null);
        setCTA2URLError(null);
        setIsDirty(true);
    }


    const goBack = () => {
        if(isDirty) {
        setPathToNavigate('/basic-automation');
        setDiscardPromptOpen(true);
        } else {
            history.push('/basic-automation');
        }
    }

    const getBannerPath = () => {
        return bannerDisplayPath;
    }

    const getIconPath = () => {
        return iconDisplayPath;
    }

    return  welcomeNotification ? <> 
        <div className="panel full-height">
                <div className="panel-header">
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div>
                            <h3 className="mb-0"><i className="icon icon-chevron-left mr-2" onClick={() => goBack()}></i>Welcome Notification</h3>
                        </div>
                        <div className="d-flex justify-content-between">
                            <button className="btn btn-sm btn-danger mr-2" onClick={() => discard()} >Discard</button>
                            <button className="btn btn-sm btn-primary" onClick={save} disabled={isSaveDisabled()}>Save</button>                                         
                        </div> 
                    </div> 
                                                
                </div>
                <div className="panel-body d-flex flex-column scrollable_y">
                    <div className="row">
                        <div className="col">
                            <div className="panel panel-bordered mb-3">
                                <div className="panel-header">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h5 className="medium mb-0">Welcome Notification Content</h5>
                                    </div>                                
                                </div>
                                <div className="panel-body d-flex flex-column scrollable_y">
                                    <div className="row">
                                        <div className="col-6 col-lg-2">
                                            <label className="thin text-light">Sent</label>
                                            <h5 className="text-dak">{roundOff(welcomeStats?.sent || 0)}</h5>
                                        </div>
                                        <div className="col-6 col-lg-2">
                                            <label className="thin text-light">Impressions</label>
                                            <h5 className="text-dak">{roundOff(welcomeStats?.delivered || 0)}</h5>
                                        </div>
                                        <div className="col-6 col-lg-2">
                                            <label className="thin text-light">Clicks</label>
                                            <h5 className="text-dak">{roundOff(welcomeStats?.opened || 0)}</h5>
                                        </div>
                                        <div className="col-6 col-lg-2 d-flex flex-column">
                                            <label className="thin text-light">Active</label>
                                            <label className="toggle-control toggle-control-sm mb-4">
                                                <input type="checkbox" checked={is_enabled} onChange={() => setIsEnabled(!is_enabled)} />
                                                <span className="control"></span>
                                            </label>
                                        </div>
                                        <div className="col col-lg-4">
                                        </div>
                                    </div>
                                    <p className="text-light my-2 thin">Show Your appreciation by sending a warm welcome notification as soon as  a user subscribers, it  makes them feel valueed and encourages engagement.</p>
                                    <div className="form-group">
                                        <div className="d-flex justify-content-between">
                                            <label className="form-label text-dark medium">Title *</label>
                                            <div>{title.length} / 100</div>
                                        </div>
                                        <div className="input-addon input-group-right">
                                            <i className="icon icon-edit"></i>
                                            <input
                                                type="text"
                                                placeholder="Notification Title"
                                                className="form-control"
                                                value={title}
                                                onChange={({target}) => handelTitleChange(target.value)}
                                                maxLength={100}    
                                            />                        
                                        </div>
                                        <span>Note: The welcome notification title will be displayed to the user. </span>
                                        { titleError && <div><span className="error-message">{titleError}</span></div>}
                                    </div>
                                    <div className="form-group">
                                        <div className="d-flex justify-content-between">
                                            <label className="form-label text-dark medium">Custom Message</label>
                                            <div>{message.length} / 300</div>
                                        </div>
                                        <div className="input-addon input-group-right">
                                            <i className="icon icon-edit"></i>
                                            <input
                                                type="text"
                                                placeholder="Notification Message"
                                                className="form-control"
                                                value={message}
                                                onChange={({target}) => handelMessageChange(target.value)}    
                                                maxLength={300}
                                            />                        
                                        </div>
                                        <span>Note: The welcome message is displayed to the user.</span>
                                        { messageError && <div><span className="error-message">{messageError}</span></div>}
                                        { messageLengthError && <div><span className="error-message">{messageLengthError}</span></div>}
                                    </div>
                                    <div className="form-group">
                                        <div className="d-flex justify-content-between">
                                            <label className="form-label text-dark medium">Welcome Link *</label>
                                            <div>{landing_url.length} / 150</div>
                                        </div>
                                        <div className="input-addon input-group-right">
                                            <i className="icon icon-edit"></i>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                value={landing_url}
                                                onChange={({target}) => handelWelcomeLinkChange(target.value)}
                                                maxLength={150}
                                            />                        
                                        </div>
                                        <span>Note: You can send a visitor to a particular link upon clicking the welcome notification. If left empty, they will land on your home page.</span>
                                        { welcomeLinkError && <div><span className="error-message">{welcomeLinkError}</span></div>}
                                    </div>
                                    <div className="form-group">
                                        <label className="medium">Welcome Banner Image</label>
                                        <div className="d-flex">                                                        
                                            <div className="form-group mb-0">                                                            
                                                <div className="d-flex align-items-center">
                                                    <div className="file-upload">                                                    
                                                        <input 
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(event) => handelBannerUpload(event)}    
                                                            ref={bannerRef}
                                                        />
                                                        <i className="icon icon-file"></i>
                                                        Select File
                                                    </div>
                                                    {bannerDisplayPath && <span className="mx-2 image-name">{bannerName}</span>}  
                                                </div>
                                            </div>
                                            { bannerDisplayPath && <button className="btn ml-2 btn-grey" onClick={() => onClearBanner()} ><i className="icon icon-close mr-2"></i>Clear</button>}
                                            {/* <button className="btn btn-grey mx-2"><i className="icon icon-search mr-2"></i>Search</button>
                                            <button className="btn btn-grey"><i className="icon icon-close mr-2"></i>Clear</button> */}
                                        </div> 
                                        <span>Note: The image will appear inside the push notification received by your readers  on chrome on windows, Recommended size 360X240 and 675X506 (2:1 Aspect Ratio).</span>                                                   
                                    </div>
                                    <div className="form-group">
                                        <label className="medium">Icon</label>
                                        <div className="d-flex">                                                        
                                            <div className="form-group mb-0">
                                                <div className="d-flex align-items-center">                                                             
                                                    <div className="file-upload">                                                    
                                                        <input 
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(event) => handelIconUpload(event)}    
                                                            ref={iconRef}
                                                        />
                                                        <i className="icon icon-file"></i>
                                                        Select File                                                    
                                                    </div>
                                                    {iconDisplayPath && <span className="mx-2 image-name">{iconName}</span>}
                                                </div>
                                            </div>
                                            {iconDisplayPath && <button className="btn ml-2 btn-grey" onClick={() => onClearIcon()} ><i className="icon icon-close mr-2"></i>Clear</button>}
                                            {/* <button className="btn btn-grey mx-2"><i className="icon icon-search mr-2"></i>Search</button>
                                            <button className="btn btn-grey"><i className="icon icon-close mr-2"></i>Clear</button> */}
                                        </div> 
                                        <span>Note: This image will be used as icon only for this push notification.</span>                                                   
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel-bordered mb-3">
                                <div className="panel-header m-1 d-flex">
                                    <h6 className="mb-0 medium mr-3 mt-1">CTA’s </h6>
                                    <label className="toggle-control toggle-control-sm mb-2">
                                        <input type="checkbox" checked={is_cta_enabled} onChange={() => deleteCta1()} />
                                        <span className="control"></span>
                                    </label>
                                </div>
                                <div className="panel-body p-4" style={{display : is_cta_enabled ? 'block' : 'none'}}>
                                    <>
                                        <h6 className="medium">Button 1</h6>
                                        <hr className="my-3"/>
                                        <div className="form-row">
                                            <div className="form-group col-12 col-md-6 col-xl-4">   
                                                <div className="d-flex justify-content-between">
                                                    <label className="form-label text-dark medium">Title *</label>
                                                    <div>{cta1Title.length} / 20</div>
                                                </div>           
                                                <div className="">
                                                    <input 
                                                        type="text" 
                                                        placeholder="e.g. Add to cart" 
                                                        className="form-control"
                                                        value={cta1Title}
                                                        onChange={({target}) => handelCTA1TitleChange(target.value)}  
                                                        maxLength={20}  
                                                    />                        
                                                </div> 
                                                { cta1TitleError && <div><span className="error-message">{cta1TitleError}</span></div>} 
                                            </div>
                                            <div className="form-group col-12 col-md-6 col-xl-4">  
                                                <div className="d-flex justify-content-between">
                                                    <label className="form-label text-dark medium">Landing URL *</label>
                                                    <div>{cta1URL.length} / 150</div>
                                                </div>
                                                <div className="input-addon input-group-right">
                                                    <input 
                                                        type="text" 
                                                        placeholder="e.g. https://mayonlinestore.com/cart" 
                                                        className="form-control url-wrapper"
                                                        value={cta1URL}
                                                        onChange={({target}) => handelCTA1URLChange(target.value)}
                                                        maxLength={150}      
                                                    />                        
                                                </div>
                                                { cta1URLError && <div><span className="error-message">{cta1URLError}</span></div>}   
                                            </div>
                                        </div> 
                                    </>
                                    { isCTA2Enabled && <>
                                        <h6 className="medium">Button 2</h6>
                                        <hr className="my-3"/>
                                        <div className="form-row">
                                            <div className="form-group col-12 col-md-6 col-xl-4">   
                                                <div className="d-flex justify-content-between">
                                                    <label className="form-label text-dark medium">Title *</label>
                                                    <div>{cta2Title.length} / 20</div>
                                                </div>          
                                                <div className="">
                                                    <input 
                                                        type="text" 
                                                        placeholder="e.g. Add to cart" 
                                                        className="form-control"
                                                        value={cta2Title}
                                                        onChange={({target}) => handelCTA2TitleChange(target.value)}
                                                        maxLength={20}    
                                                        />                        
                                                </div>  
                                                { cta2TitleError && <div><span className="error-message">{cta2TitleError}</span></div>} 
                                            </div>
                                            <div className="form-group col-12 col-md-6 col-xl-4">  
                                                <div className="d-flex justify-content-between">
                                                    <label className="form-label text-dark medium">Landing URL *</label>
                                                    <div>{cta2URL.length} / 150</div>
                                                </div>
                                                <div className="input-addon input-group-right">
                                                    <input 
                                                        type="text" 
                                                        placeholder="e.g. https://mayonlinestore.com/cart" 
                                                        className="form-control url-wrapper"
                                                        value={cta2URL}
                                                        onChange={({target}) => handelCTA2URLChange(target.value)} 
                                                        maxLength={150}
                                                    />                        
                                                </div>
                                                { cta2URLError && <div><span className="error-message">{cta2URLError}</span></div>}   
                                            </div>
                                        </div> 
                                    </>}
                                    
                                { !isCTA2Enabled && <button className="btn btn-outline" onClick ={() => setCTA2Enabled(true)} ><i className="icon icon-add mr-2"></i>Add another</button>}
                                { isCTA2Enabled && <button className="btn btn-danger" onClick ={() => deleteCta2()} ><i className="icon icon-delete mr-2"></i>Delete another</button>}
                                </div>
                            </div> 
                        </div>
                            <NotificationPreview
                                title={title}
                                message={message}
                                banner={getBannerPath()}
                                icon={getIconPath()}
                                is_cta_enabled = {is_cta_enabled}
                                isCTA2Enabled = {(is_cta_enabled && isCTA2Enabled)}
                                button={cta1Title}
                                addl_button={cta2Title}
                            />
                    </div>
                </div>
        </div>

        { openCropper && <IconCropper
                open={openCropper} 
                onClose={onCancelIconCrop} 
                url={iconPath} 
                onSave={getCroppedIcon} 
            />
        }

        { openBannerCropper && <IconCropper
                        open={openBannerCropper} 
                        onClose={onCancelBannerCrop} 
                        url={bannerPath} 
                        onSave={getCroppedBanner}
                        aspect={2/1}
                    />
        }


    </> 
    : null
}

export default WelcomeNotification;